import { Breadcrumb } from "antd";
import { useResourceContext } from "./ResourceContext";
import { useResource, useResourceParams } from "@refinedev/core";
import { useTranslation } from "react-i18next";
import { Link } from "@/components/common/Link";

export const TopBreadcrumb = ({disableId="false"}) => {
  const { t } = useTranslation();
  const { rootState } = useResourceContext();
  const { action, id, formAction, resource } = useResourceParams();
  const items = [];
  if (rootState.tenantName) {
    items.push({
      title: `Tenant: ${rootState.tenantName}`,
    });
  } else {
    items.push({
      title: "Home",
    });
  }
  if (resource) {
    const resourceLabel = resource.meta?.label || resource.name;
    items.push({
      title: action === 'list' ? resourceLabel : <Link to={`${resource.list}`}>{ resourceLabel }</Link>,
    });
  }
  if (id && disableId !== 'true') {
    items.push({
      title: action === 'show' ? id : <Link to={`${resource.list}/show/${id}`}>{id}</Link>,
    });
  }
  if (action && action !== 'show') {
    items.push({
      title: t(`actions.${action}`),
    });
  }
  return (
    <Breadcrumb items={items} />
  );
};